import {AddressProps} from 'modules/addresses/types';
import addressesKeys from 'modules/addresses/util/addresses-keys';
import React from 'react';
import useProjection from 'shared/migration-hooks/use-projection';
import List from 'shared/layout/list';

const Addresses: React.FC = () => {
  const projection = useProjection<AddressProps>('addresses', [
    'name',
    'street',
    'number',
    'city.name',
    'state',
  ]);

  return (
    <List<AddressProps>
      titleBar={{
        title: 'Endereços',
        actionButton: {title: 'NOVO ENDEREÇO', to: 'create'},
      }}
      {...{
        table: {
          projection: {
            ...projection,
            options: ['name', 'street', 'number', 'city.name', 'state'],
          },
          translatedPropsKey: 'AddressProps',
          url: '/addresses',
        },
        queryKey: addressesKeys.list(),
      }}
    />
  );
};

export default Addresses;
